/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSouscriptionPricingMutation from '../graphql/mutations/SaveSouscriptionPricingMutation.js';

export const useSaveSouscriptionPricingMutation = () => {
  return useCommitMutation(SaveSouscriptionPricingMutation, {
    dataProp: 'saveSouscriptionPricing_M_souscription_pricing'
  });
};

export default useSaveSouscriptionPricingMutation;
